import { render, staticRenderFns } from "./WaitingApproval.vue?vue&type=template&id=7f45e614&"
import script from "./WaitingApproval.vue?vue&type=script&lang=js&"
export * from "./WaitingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports